export default function quickAdd(productData) {
  return {
    product: productData,
    isOpen: false,
    loading: false,
    added: false,
    selectedOptions: {},

    init() {
      if (!this.product) return;
      const first = this.product.variants?.find(v => v.available) ?? this.product.variants?.[0];

      if (first) {
        this.product.options?.forEach((_, i) => {
          this.selectedOptions[i] = first[`option${i + 1}`];
        });
      }
    },

    get hasOnlyDefaultVariant() {
      if (!this.product) return true;
      return this.product.has_only_default_variant || this.product.variants?.length <= 1;
    },

    get selectedVariant() {
      if (this.hasOnlyDefaultVariant) return this.product.variants?.[0] ?? null;

      return this.product.variants?.find(v =>
        this.product.options.every((_, i) => v[`option${i + 1}`] === this.selectedOptions[i])
      ) ?? null;
    },

    get allOptionsSelected() {
      if (!this.product || this.hasOnlyDefaultVariant) return true;
      return this.product.options?.every((_, i) => this.selectedOptions[i] != null) ?? false;
    },

    getOptionValues(optionIndex) {
      return [...new Set(this.product.variants.map(v => v[`option${optionIndex + 1}`]))];
    },

    isOptionUnavailable(optionIndex, value) {
      return !this.product.variants?.some(v => {
        if (!v.available) return false;

        const othersMatch = this.product.options.every((_, i) => {
          if (i === optionIndex) return true;
          return this.selectedOptions[i] == null || v[`option${i + 1}`] === this.selectedOptions[i];
        });

        return othersMatch && v[`option${optionIndex + 1}`] === value;
      });
    },

    open() {
      if (this.hasOnlyDefaultVariant) {
        this.addToCart();
        return;
      }

      this.isOpen = true;
    },

    async addToCart() {
      if (!this.selectedVariant?.available) return;

      this.loading = true;

      try {
        const res = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: this.selectedVariant.id, quantity: 1 }),
        });

        if (!res.ok) throw new Error();

        this.isOpen = false;

        this.$dispatch('quickadd:success');
      } catch {
        // fail silently for now
      } finally {
        this.loading = false;
      }
    },
  };
}
